import React, { useEffect, useState } from "react";
import { AppBar, Tabs, Tab } from "@mui/material";
import { useApi } from "../../../service/ApiContext";
import Loader, { LocalStorage } from "../../../utils/Utils";
import Logger from "../../../utils/Logger";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import redImage from "../../../assets/images/LiveSession/redActive.png";
import "../styles/LiveSessionTab.css";
import { TabNavigatorProps } from "../../../interface/TabNavigationProps";
import dropdownArrow from "../../../assets/images/Profile_Img/arrowDropDown.png";

import { FaRedo, FaSyncAlt } from "react-icons/fa";
import { setSelectedValues } from "../data/reducer/eventReducer";
import { setPrograms } from "../data/reducer/ProgramDetailReducer";
const LiveTabNavigator: React.FC<TabNavigatorProps> = ({
  activeTab,
  onTabChange,
  onProgramSelect,
  refreshClicked,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [filter, setFilter] = useState("All Programs");

  // Handle dropdown selection
  const handleOptionClick = (program: {
    program_title: string;
    program_id: string;
  }) => {
    setFilter(program.program_title);
    setIsDropdownOpen(false);
    dispatch(
      setSelectedValues([
        {
          program_title: program.program_title,
          program_id: program.program_id,
        },
      ]),
    );
    // Check before calling
    if (onProgramSelect) {
      onProgramSelect(program.program_id);
    }
  };

  const api = useApi();
  const dispatch = useDispatch();
  const getProgram = async () => {
    Loader.showLoading("Loading...");

    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    const institute_id = LocalStorage.getLocalData("institute_id");
    try {
      const response = await api.get<any>(
        // `/institutes/${institute_id}/program`
        `/eprogram/${institute_id}`,
      );
      Logger.info("respocedata", response.data.programs);
      if (response.data.error) {
        dispatch(setPrograms([]));
        return;
      }
      if (response.data.programs && response.data.programs.length > 0) {
        Logger.info("response data", response.data.programs);
        dispatch(setPrograms(response.data.programs));
        Logger.info("redux data program", listProgramData);
        Logger.info("response", response.data);
      } else {
        dispatch(setPrograms([]));
      }
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
    }
  };
  useEffect(() => {
    getProgram();
  }, []);
  const listProgramData = useSelector(
    (state: RootState) => state.programs.programs,
  );

  const [selectedProgram, setSelectedProgram] = useState<string[]>([]);
  const [selectedProgramId, setSelectedProgramId] = useState<string[]>([]);
  const handleSelectionChange = (
    selected: { program_title: string; program_id: string }[],
  ) => {
    // Extract titles and IDs from the selected array
    const titles = selected.map((item) => item.program_title);
    const ids = selected.map((item) => item.program_id);
    const selectedValues = selected.map((item) => ({
      program_title: item.program_title,
      program_id: item.program_id,
    }));
    dispatch(setSelectedValues(selectedValues));
    setSelectedProgram(titles); // Store the selected program titles
    setSelectedProgramId(ids); // Store the selected program IDs
  };
  const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  return (
    <AppBar position="static" className="liveSession-tab-navigator">
      <div className="liveSession-tab-wrapper">
        <div className="landingPage-left-section">
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => onTabChange(newValue)}
            sx={{
              "& .MuiTabs-flexContainer": {
                gap: "20px", // 👈 gap between tabs
              },

              "& .MuiTabs-indicator": {
                background: "#395B9C",
                height: "5px",
                borderRadius: "4px 4px 0px 0px",
                transition: "left 0.3s ease",
              },
              "& .MuiTab-root": {
                // marginLeft: "20px",
                fontSize: "18px",
                fontWeight: "400", // Default font weight
                color: "#555", // Default color
                textTransform: "none",
              },
              "& .Mui-selected": {
                fontWeight: "700", // Bold active tab
                color: "#395B9C", // Active tab color
              },
            }}
          >
            <Tab
              className={`liveSession-tab ${activeTab === 0 ? "selected" : ""}`}
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={redImage}
                    alt="Profile"
                    style={{
                      marginRight: "10px",
                      width: "10px",
                      height: "10px",
                    }}
                  />
                  <span className="liveSession-tab-label">Live </span>
                </div>
              }
              style={{ borderTopLeftRadius: "10px" }}
            />
            <Tab
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="liveSession-tab-label"> Upcoming </span>
                </div>
              }
              className={`liveSession-tab ${activeTab === 1 ? "selected" : ""}`}
            />
            <Tab
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="liveSession-tab-label"> Expired </span>
                </div>
              }
              className={`liveSession-tab ${activeTab === 2 ? "selected" : ""}`}
              style={{ borderTopRightRadius: "10px" }}
            />
          </Tabs>{" "}
          {/* Tabs on the Left */}
        </div>
        <div className="landingPage-right-section">
          <div
            onClick={refreshClicked}
            style={{
              cursor: "pointer",
              alignContent: "center",
            }}
            title="Refresh"
          >
            <FaRedo size={18} color="#242730" />
          </div>
          <div className="liveSession-CustomDropdown">
            <div
              className="liveSession-CustomDropdownSelected"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              title={listProgramData.length > 0 ? filter : "Select Program"}
            >
              {/* {listProgramData.length > 0 ? filter : "Select Program"}  */}
              {truncateText(
                listProgramData.length > 0 ? filter : "Select Program",
                20,
              )}

              <img
                src={dropdownArrow}
                alt="Dropdown Arrow"
                className="liveSession-DropdownArrowImg"
              />
            </div>

            {isDropdownOpen && (
              <ul className="liveSession-CustomDropdownOptions">
                {/* Show "No Programs Found" if the list is empty */}
                {listProgramData.length === 0 ? (
                  <li
                    className="liveSession-DropdownOption"
                    style={{ color: "#999", cursor: "default" }}
                  >
                    No Programs Found
                  </li>
                ) : (
                  <>
                    {/* Show "All Programs" option */}
                    <li
                      className="liveSession-DropdownOption"
                      onClick={() =>
                        handleOptionClick({
                          program_title: "All Programs",
                          program_id: "",
                        })
                      }
                    >
                      All Programs
                    </li>

                    {/* Show list of available programs */}
                    {listProgramData.map((program) => (
                      <li
                        key={program.program_id}
                        className="liveSession-DropdownOption"
                        onClick={() => handleOptionClick(program)}
                      >
                        {program.program_title}
                      </li>
                    ))}
                  </>
                )}
              </ul>
            )}
          </div>
        </div>
      </div>
    </AppBar>
  );
};

export default LiveTabNavigator;
